import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {};

const slice = createSlice({
  name: 'rsvp',
  initialState: reHydrateStore('rsvp') || initialState,
  reducers: {
    setRsvp: (state, { payload }) => payload,
    restore: () => null,
  },
});

export const { setRsvp, restore } = slice.actions;

export default slice.reducer;

export const selectRsvp = (state) => state.rsvp;
